(() => {
  if (window.mamMarketNavigationBound) return;
  window.mamMarketNavigationBound = true;

  const sizeOpenMenus = () => {
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    document.querySelectorAll('[data-mm-departments][open] .mm-mega').forEach((panel) => {
      const availableHeight = Math.max(0, Math.floor(viewportBottom - panel.getBoundingClientRect().top - 12));
      panel.style.maxHeight = `${availableHeight}px`;
    });
  };
  let menuSizingFrame = 0;
  const scheduleMenuSizing = () => {
    if (menuSizingFrame) return;
    menuSizingFrame = window.requestAnimationFrame(() => {
      menuSizingFrame = 0;
      sizeOpenMenus();
    });
  };

  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches('[data-mm-departments]')) return;
    if (menu.open) scheduleMenuSizing();
    else menu.querySelector('.mm-mega')?.style.removeProperty('max-height');
  }, true);
  window.addEventListener('resize', scheduleMenuSizing);
  window.addEventListener('scroll', scheduleMenuSizing, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleMenuSizing);
  window.visualViewport?.addEventListener('scroll', scheduleMenuSizing, { passive: true });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-mm-departments][open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mm-departments][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('cart:update', (event) => {
    const count = event.detail?.resource?.item_count;
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-mm-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  });

  const header = document.querySelector('.mm-market-layout #header-group') || document.getElementById('shopify-section-mam-market-header');
  if (header) {
    const measureHeader = () => {
      const height = Math.max(0, header.offsetHeight);
      document.body.style.setProperty('--mm-header-height', `${height}px`);
      document.body.style.setProperty('--mm-native-header-height', `${height}px`);
      scheduleMenuSizing();
    };
    measureHeader();
    new ResizeObserver(measureHeader).observe(header);
  }
})();
